import { Eye, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useMemberView } from "@/contexts/MemberViewContext";

const MemberViewBanner = () => {
  const { viewingMember, clearViewingMember } = useMemberView();
  const navigate = useNavigate();

  if (!viewingMember) return null;

  return (
    <div className="bg-primary/10 border-b border-primary/20 px-4 py-2 flex items-center justify-between gap-3 shrink-0">
      <div className="flex items-center gap-2 text-xs">
        <Eye className="w-3.5 h-3.5 text-primary" />
        <span className="text-primary font-medium">Viewing as member:</span>
        <span className="font-semibold text-foreground">{viewingMember.name}</span>
      </div>
      <button
        type="button"
        onClick={() => {
          clearViewingMember();
          navigate(-1);
        }}
        className="flex items-center gap-1 text-[10px] font-medium text-primary hover:text-primary/80 transition-colors px-2 py-1 rounded-md hover:bg-primary/10"
      >
        <X className="w-3 h-3" />
        Exit Preview
      </button>
    </div>
  );
};

export default MemberViewBanner;
